<div class="history_page">
	<ngx-spinner type="ball-scale-multiple" size="medium" [name]="blockLoader"></ngx-spinner>
	<div class="mylibrary_page">
		<app-header [showBackButtonBlack]="showBackButtonBlack" [showPageRoute]="showPageRoute"
			[headerTitle]="headerTitle"></app-header>

		<mdb-tabs>
			<mdb-tab title="All History">
				<div class="category_table_container desktop_table_all_history">
					<div class="category_table">
						<div class="program_name">Title</div>
						<div class="program_name center_head">Started</div>
						<div class="program_name center_head">Completed</div>
						<div class="program_name center_head">Time Spent</div>
						<div class="program_name center_head">Length</div>
						<div class="program_name center_head">Sections</div>
						<div class="program_name center_head">Difficulty</div>
						<div class="program_name center_head">Layers</div>
						<div class="program_name">Status</div>
					</div>

					<ng-container *ngFor="let categ of filteredCategories">
						<div class="history_table_head">
							<!-- Management / Recruitment -->
							{{categ.name}}
						</div>

						<div *ngFor="let program of getProgramsByCategory(categ.id)">
							<!-- <div *ngIf="!program.completedAt"> -->
							<ng-container *ngIf="program.category?.id === categ?.id">
								<div class="category_deatils_row_progress">
									<div class="program_details prog_name">{{ program.name }}</div>
									<div class="program_details date center_col">{{ program.startedAt?.toDate() | date:
										"MM/dd/yy" }}</div>
									<div class="program_details date center_col"> <span *ngIf="program.completedAt"> {{
											program.completedAt?.toDate() | date: "MM/dd/yy" }}</span></div>
									<div class="program_details center_col">
										<span *ngIf="program.completedAt">
											{{ getTimeToComplete(program.startedAt?.toDate(),
											program.completedAt?.toDate()) }}
										</span>

									</div>
									<div class="program_details center_col">
										<div class="card_footerIcn">
											<img src="../../assets/images/Time Circle.svg" alt="">
										</div>
										<div class="card_footer_sub_head">
											{{ getLearningHrs(program.totalLearningHrs) }}
										</div>
									</div>

									<div class="program_details center_col">
										<div class="card_footerIcn">
											<img src="../../assets/images/Category.svg" alt="">
										</div>
										<div class="card_footer_sub_head" *ngIf="program.numberOfSections; else getNumSections">
											{{ program.numberOfSections }}
										</div>
										<ng-template #getNumSections>
											{{ getTotalNumberOfSections(program.sections) }}
										</ng-template>
									</div>

									<div class="program_details center_col">
										<div class="level_easy" *ngIf="program.difficultyLevel">
											<span class="first colored"></span>
											<span class="second colored"
												*ngIf="program.difficultyLevel === 'medium' || program.difficultyLevel === 'hard'; else easyDifficulty"></span>
											<ng-template #easyDifficulty>
												<span class="second transparent"></span>
											</ng-template>
											<span class="third colored"
												*ngIf="program.difficultyLevel === 'hard'; else notHardDifficulty"></span>
											<ng-template #notHardDifficulty>
												<span class="third transparent"></span>
											</ng-template>
										</div>
										<div class="level_easy" *ngIf="!program.difficultyLevel">
											<span class="first colored"></span>
											<span class="second colored"></span>
											<span class="third transparent"></span>
										</div>
									</div>
									<div class="program_details center_col">
										1
									</div>
									<div class="program_details complete_col">
										<span class="completeBtn_green" *ngIf="program.progress !== 100">
											In Progress
										</span>
										<span class="completeBtn" *ngIf="program.progress === 100">
											Complete
										</span>
									</div>
								</div>
							</ng-container>
							<!-- </div> -->
						</div>
					</ng-container>
				</div>

				<!-- mobile all history -->

				<div class="mobile_table_all_history">
					<app-mobile-history-page [showAllHistory]="showAllHistory"></app-mobile-history-page>
				</div>
			</mdb-tab>

			<mdb-tab title="Completed">
				<div class="category_table_container desktop_table_all_history">
					<div class="category_table">
						<div class="program_name">Title</div>
						<div class="program_name center_head">Started</div>
						<div class="program_name center_head">Completed</div>
						<div class="program_name center_head">Time Spent</div>
						<div class="program_name center_head">Length</div>
						<div class="program_name center_head">Sections</div>
						<div class="program_name center_head">Difficulty</div>
						<div class="program_name center_head">Layers</div>
						<div class="program_name">Status</div>
					</div>

					<ng-container *ngFor="let categ of filteredCategories">
						<div class="history_table_head">
							<!-- Management / Recruitment -->
							{{categ.name}}
						</div>

						<div *ngFor="let program of getProgramsByCategory(categ.id)">
							<div *ngIf="program.progress === 100">
								<div class="category_deatils_row_progress">
									<div class="program_details prog_name">{{ program.name }}</div>
									<div class="program_details date center_col">{{ program.startedAt?.toDate() | date:
										"MM/dd/yy" }}
									</div>
									<div class="program_details date center_col">
										<span *ngIf="program.completedAt">
											{{ program.completedAt?.toDate() | date: "MM/dd/yy" }}
										</span>
									</div>

									<div class="program_details center_col">
										<span *ngIf="program.completedAt">
											{{ getTimeToComplete(program.startedAt?.toDate(),
											program.completedAt?.toDate())
											}}
										</span>
									</div>
									<div class="program_details center_col">
										<div class="card_footerIcn">
											<img src="../../assets/images/Time Circle.svg" alt="">
										</div>
										<div class="card_footer_sub_head">
											{{ getLearningHrs(program.totalLearningHrs) }}
										</div>
									</div>

									<div class="program_details center_col">
										<div class="card_footerIcn">
											<img src="../../assets/images/Category.svg" alt="">
										</div>
										<div class="card_footer_sub_head" *ngIf="program.numberOfSections; else getNumSections">
											{{ program.numberOfSections }}
										</div>
										<ng-template #getNumSections>
											{{ getTotalNumberOfSections(program.sections) }}
										</ng-template>
									</div>

									<div class="program_details center_col">
										<div class="level_easy" *ngIf="program.difficultyLevel">
											<span class="first colored"></span>
											<span class="second colored"
												*ngIf="program.difficultyLevel === 'medium' || program.difficultyLevel === 'hard'; else easyDifficulty"></span>
											<ng-template #easyDifficulty>
												<span class="second transparent"></span>
											</ng-template>
											<span class="third colored"
												*ngIf="program.difficultyLevel === 'hard'; else notHardDifficulty"></span>
											<ng-template #notHardDifficulty>
												<span class="third transparent"></span>
											</ng-template>
										</div>
										<div class="level_easy" *ngIf="!program.difficultyLevel">
											<span class="first colored"></span>
											<span class="second colored"></span>
											<span class="third transparent"></span>
										</div>
									</div>
									<div class="program_details center_col">
										1
									</div>
									<div class="program_details complete_col">
										<span class="completeBtn">
											Complete
										</span>
									</div>

								</div>
							</div>
						</div>
					</ng-container>
					<!-- </mdb-tab> -->
				</div>

				<!-- mobile all history -->

				<div class="mobile_table_all_history">
					<app-mobile-history-page [showCompletedHistory]="showCompletedHistory"></app-mobile-history-page>
				</div>
			</mdb-tab>

			<mdb-tab title="In Progress">
				<div class="category_table_container desktop_table_all_history">
					<div class="category_table category_table_progress">
						<div class="program_name">Title</div>
						<div class="program_name center_head">Started</div>

						<div class="program_name center_head">Completed</div>
						<div class="program_name center_head">Time Spent</div>
						<div class="program_name center_head">Length</div>
						<div class="program_name center_head">Sections</div>
						<div class="program_name center_head">Difficulty</div>
						<div class="program_name center_head">Layers</div>
						<div class="program_name">Status</div>
					</div>

					<ng-container *ngFor="let categ of filteredCategoriesForProgress">
						<div class="history_table_head">
							<!-- Management / Recruitment -->
							{{categ.name}}
						</div>

						<div *ngFor="let program of getProgramsByCategory(categ.id)">
							<div *ngIf="program.progress !== 100">
								<div class="category_deatils_row_progress">
									<div class="program_details prog_name">{{ program.name }}</div>
									<div class="program_details date center_col">{{ program.startedAt?.toDate() | date:
										"MM/dd/yy" }}
									</div>
									<div class="program_details date center_col"></div>
									<div class="program_details date center_col"></div>
									<div class="program_details center_col">
										<div class="card_footerIcn">
											<img src="../../assets/images/Time Circle.svg" alt="">
										</div>
										<div class="card_footer_sub_head">
											{{ getLearningHrs(program.totalLearningHrs) }}
										</div>

									</div>
									<div class="program_details center_col">
										<div class="card_footerIcn">
											<img src="../../assets/images/Category.svg" alt="">
										</div>
										<div class="card_footer_sub_head" *ngIf="program.numberOfSections; else getNumSections">
											{{ program.numberOfSections }}
										</div>
										<ng-template #getNumSections>
											{{ getTotalNumberOfSections(program.sections) }}
										</ng-template>
									</div>
									<div class="program_details date center_col">
										<div class="level_easy" *ngIf="program.difficultyLevel">
											<span class="first colored"></span>
											<span class="second colored"
												*ngIf="program.difficultyLevel === 'medium' || program.difficultyLevel === 'hard'; else easyDifficulty"></span>
											<ng-template #easyDifficulty>
												<span class="second transparent"></span>
											</ng-template>
											<span class="third colored"
												*ngIf="program.difficultyLevel === 'hard'; else notHardDifficulty"></span>
											<ng-template #notHardDifficulty>
												<span class="third transparent"></span>
											</ng-template>
										</div>
										<div class="level_easy" *ngIf="!program.difficultyLevel">
											<span class="first colored"></span>
											<span class="second colored"></span>
											<span class="third transparent"></span>
										</div>
									</div>
									<div class="program_details date center_col">1</div>
									<div class="program_details complete_col">
										<span class="completeBtn_green">
											In Progress
										</span>
									</div>
								</div>
							</div>
						</div>
					</ng-container>
				</div>

				<div class="mobile_table_all_history">
					<app-mobile-history-page [showInProgress]="showInProgress"></app-mobile-history-page>
				</div>
			</mdb-tab>
		</mdb-tabs>
	</div>
</div>